/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playbar_Add_HighlightsInputs */

const en_playbar_add_highlights = /** @type {(inputs: Playbar_Add_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add to Highlights`)
};

const es_playbar_add_highlights = /** @type {(inputs: Playbar_Add_HighlightsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar a destacados`)
};

/**
* | output |
* | --- |
* | "Add to Highlights" |
*
* @param {Playbar_Add_HighlightsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const playbar_add_highlights = /** @type {((inputs?: Playbar_Add_HighlightsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playbar_Add_HighlightsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_playbar_add_highlights(inputs)
	return en_playbar_add_highlights(inputs)
});